import { NgRedux } from "@angular-redux/store";
import { Injectable } from "@angular/core";

export interface CustomerAction {
    type: string;
    payload: Object;
}

@Injectable()
export class CustomerActions {

    static GET_CUSTOMER = "GET_CUSTOMER";
    static GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS";
    static GET_CUSTOMER_SIBLINGS = "GET_CUSTOMER_SIBLINGS";
    static GET_CUSTOMER_SIBLINGS_SUCCESS = "GET_CUSTOMER_SIBLINGS_SUCCESS";

    constructor(private ngRedux: NgRedux<Object>) { }

    getActiveCustomer(clientId): void {
        this.ngRedux.dispatch({ type: CustomerActions.GET_CUSTOMER, payload: clientId });
    }

    getCustomerSiblings(clientId): void  {
        this.ngRedux.dispatch({ type: CustomerActions.GET_CUSTOMER_SIBLINGS, payload: clientId });
    }
}
